import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { User } from '../../../models/user.model';

@Component({
  selector: 'morva-delete-access',
  templateUrl: './delete-access.component.html',
  styleUrls: ['./delete-access.component.scss'],
})
export class DeleteAccessComponent implements OnInit {
  user: User;
  accessType: string;
  message: string;
  asset: string;

  constructor(protected dialogRef: NbDialogRef<any>) { }

  ngOnInit(): void {
   this.setMessage();
  }
  setMessage() {
    let name: string;
    let type: string;
    switch (this.user.accessRecipientType) {
      case 'Solo':
        name = this.user.fullName;
        type = 'کاربر';
        break;
      case 'Group':
        name = this.user.groupName;
        type = 'گروه کاربری';
        break;
    }
    switch (this.accessType) {
      case 'Dashboard':
        this.asset = 'داشبورد';
        this.message = 'آیا از حذف مجوزهای تنظیم شده برای ' + type + ' ' + name + ' ' + 'در داشبورد اطمینان دارید؟';
        break;
      case 'DataSource':
        this.asset = 'منبع داده';
        this.message = 'آیا از حذف مجوزهای تنظیم شده برای ' + type + ' ' + name + ' ' + 'در منبع داده اطمینان دارید؟';
        break;
      case 'DashboardGroup':
        this.asset = 'گروه داشبوردی';
        this.message = 'آیا از حذف مجوزهای تنظیم شده برای ' + type + ' ' + name + ' ' +
        'در همه داشبوردهای گروه داشبوردی اطمینان دارید؟';
        break;
      case 'Chart':
        this.asset = 'نمودار';
        this.message = 'آیا از حذف مجوزهای تنظیم شده برای ' + type + ' ' + name + ' ' + 'در نمودار اطمینان دارید؟';

    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  onDeleteClick() {
    this.dialogRef.close(true);
  }

}
